<ng-container *ngIf=" (inputConfig$ | async) as inputConfig">
    @if(datumIsInvalid || godinaIsInvalid){
        <span style="color: red; list-style: none;"> Vrijeme "do" ne može biti prije vremena "od"
        </span> <br>
    }
    @if(godinaIsOutOfRange){
        <span style="color: red; list-style: none;"> Godina ne može biti manja od 1 i veća od 9999
        </span> <br>
    }
    <ng-container [ngSwitch]="selectedOption()">
        <ng-container *ngSwitchCase="'Datum'">
            <p-calendar #datetimeBox *ngIf="!this.inputParam.attributeMetadata.read_only; else isReadOnlyDate" 
                type="date" 
                [name]="inputConfig.formControlName" 
                [formControl]="datumFormControl"
                [readonlyInput]="inputConfig.readOnly"
                [disabled]="inputConfig.disabled"
                dateFormat="dd.mm.yy."
                appendTo="body"
                [showIcon]="true" 
                placeholder="Npr. 01.01.1643." 
                [monthNavigator]="true"
                [yearNavigator]="false"  
                [showButtonBar]="true" 
                [showOnFocus]="false"
                (onSelect)="onSelectOrInputDate($event)"
                (onBlur)="onSelectOrInputDate()"
                [locale]="locale">
            </p-calendar>
            <ng-template #isReadOnlyDate>
                <ntap-input-label [data]="datum | date:'dd.MM.YYYY.'"></ntap-input-label>
            </ng-template>
        </ng-container>

        <ng-container *ngSwitchCase="'Godina'">
            <ng-container *ngIf="!this.inputParam.attributeMetadata.read_only; else isReadOnly">
                <p-inputNumber #inputBox 
                    type="number" 
                    [readonly]="inputConfig.readOnly"
                    [name]="inputConfig.formControlName" 
                    [formControl]="godinaFormControl"
                    [disabled]="inputConfig.disabled" 
                    [style]="{ width: '160px' }" 
                    placeholder="Unesite godinu"
                    (onInput)="godinaFormControl.markAsTouched(); validiraj()"
                    [useGrouping]="false"></p-inputNumber>
            </ng-container>
            <ng-template #isReadOnly>
                <ntap-input-label [data]="godina"></ntap-input-label>
            </ng-template>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!range">
        <ng-container *ngIf="!inputParam.attributeMetadata.read_only; else isReadOnly">
            <p-dropdown class="vrijeme" [options]="options" [(ngModel)]="selectedOption"></p-dropdown>
        </ng-container>
        <ng-template #isReadOnly>
            <ntap-input-label [data]="datum"></ntap-input-label>
        </ng-template>
    </ng-container>
</ng-container>
